import emitter from "../events/config";
import { createCallbackConversation, getConversationData, getRes1000URLData, setConversationData } from "../services/conversation";
import { setUserPresence } from "../services/users";
import { logtailLog } from "../utils/logtailLogger";

const queueId = `${process.env.REACT_APP_QUEUE_ID}`;
const presenceIdIn = `${process.env.REACT_APP_SET_QUEUE_ID}`;
const presenceIdOut = `${process.env.REACT_APP_REMOVE_QUEUE_ID}`;

var urlAttributes = undefined;

export const sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export const clearLocalStorage = async () => {
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('flowCalled');
}

export const getUrlParameters = async () => {
    console.log('### Iniciado getUrlParameters');
    if (urlAttributes === undefined) {
        console.log('### getUrlParameters: indo para setUrlParameters');
        await setUrlParameters();
    }

    console.log('### getUrlParameters urlAttributes', urlAttributes);
    console.log('### Finalizado getUrlParameters');
    return urlAttributes;
}

export const setUrlParameters = async () => {
    console.log('### Iniciado setUrlParameters');
    var attr = await getRes1000URLData();
    urlAttributes = attr;

    console.log('### setUrlParameters urlAttributes: ', urlAttributes);
    console.log('### Finalizado setUrlParameters');
    return urlAttributes;
}

export const executeCallNow = async (callbackNumbers) => {
    await createCallbackConversation(callbackNumbers, queueId);
}

export const setAgentInQueue = async () => {
    console.log('### Response: Iniciando setAgentInQueue');

    let userId = sessionStorage.getItem('userId');
    await setUserPresence(userId, presenceIdIn);

    console.log('### Response: Finalizando setAgentInQueue');
}

export const removeAgentInQueue = async () => {
    console.log('### Response: Iniciando removeAgentInQueue');

    let userId = sessionStorage.getItem('userId');
    await setUserPresence(userId, presenceIdOut);

    console.log('### Response: Finalizando removeAgentInQueue');
}

export const eventsListenerStart = async (event) => {
    console.log('### event start', event)
}

export const eventsListener = async (event) => {
    const dataParse = JSON.parse(event.data);
    const dataTopic = dataParse.eventBody.participants;

    // caso não tiver o topico.
    if (!dataTopic) { return; }

    await setConversationData();
    const attaches = await getConversationData();

    // chamada encerrada via tranferencia.
    if (attaches["dt_call_transferencia"]) {
        logtailLog('Transfer realizado', 'info', {
            empresa: attaches["dt_call_empresa"],
            action: 'Chamada encerrada via tranferencia.',
            attaches
        });
        return;
    }

    for (let i = 0; i < dataTopic.length; i++) {
        console.log('### eventsListener dataTopic element ', dataTopic[i]);
        console.log('### eventsListener disconnectType ', dataTopic[i].disconnectType);
        console.log('### eventsListener direction ', dataTopic[i].direction);
        console.log('### eventsListener purpose ', dataTopic[i].purpose);
        console.log('### eventsListener name ', dataTopic[i].name);
        console.log('### eventsListener state ', dataTopic[i].state);

        // chamada encerrada para quem está monitorando.
        if (dataTopic[i].monitoredParticipantId) {
            logtailLog('Monitoria encerrada', 'info', {
                empresa: attaches["dt_call_empresa"],
                action: 'chamada encerrada para quem está monitorando.',
                attaches,
                disconnect_type: dataTopic[i].disconnectType,
                direction: dataTopic[i].direction,
                purpose: dataTopic[i].purpose,
                state: dataTopic[i].state
            });
            return;
        }

        // chamada encerrada para quem está consultando.
        if (dataTopic[i].consultParticipantId) {
            logtailLog('Consulta encerrada', 'info', {
                empresa: attaches["dt_call_empresa"],
                action: 'chamada encerrada para quem está consultando.',
                attaches,
                disconnect_type: dataTopic[i].disconnectType,
                direction: dataTopic[i].direction,
                purpose: dataTopic[i].purpose,
                state: dataTopic[i].state
            });
            return;
        }

        // chamada encerrada com SUPORTE_MMGD_CEC e SUPORTE_OUVIDORIA_CEC.
        if (dataTopic[i].name === 'SUPORTE_MMGD_CEC') {
            logtailLog('SUPORTE_MMGD_CEC realizado', 'info', {
                empresa: attaches["dt_call_empresa"],
                action: 'Chamada encerrada para o SUPORTE_MMGD_CEC',
                attaches,
                disconnect_type: dataTopic[i].disconnectType,
                direction: dataTopic[i].direction,
                purpose: dataTopic[i].purpose,
                state: dataTopic[i].state
            });
            return;
        }
        if (dataTopic[i].name === 'SUPORTE_OUVIDORIA_CEC') {
            logtailLog('SUPORTE_OUVIDORIA_CEC realizado', 'info', {
                empresa: attaches["dt_call_empresa"],
                action: 'Chamada encerrada para o SUPORTE_OUVIDORIA_CEC',
                attaches,
                disconnect_type: dataTopic[i].disconnectType,
                direction: dataTopic[i].direction,
                purpose: dataTopic[i].purpose,
                state: dataTopic[i].state
            });
            return;
        }

        // chamada encerrada que acionarão o poopup.
        if (dataTopic[i].direction === "inbound"
            && dataTopic[i].purpose === "agent"
            && dataTopic[i].state === "disconnected") {

            if (dataTopic[i].disconnectType === "peer"
                || dataTopic[i].disconnectType === "transfer"
                || dataTopic[i].disconnectType === "client") {

                logtailLog('Poopup Acionado!', 'info', {
                    action: 'Acionado o poopup após chamada finalizada',
                    attaches,
                    disconnect_type: dataTopic[i].disconnectType,
                    direction: dataTopic[i].direction,
                    purpose: dataTopic[i].purpose,
                    state: dataTopic[i].state
                });
                emitter.emit('isCallBack', dataTopic[i].disconnectType);
            }
        }

    }
    return;
}

